import { render } from "./PrivacyPolicy.vue?vue&type=template&id=fc704032"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=fc704032&lang=css"
script.render = render

export default script